// Team-datat visas på Om-sidan och intill bokningsformuläret på kontaktsidan.
// TODO: Byt ut placeholder-fälten (name, photo) mot riktiga namn och bilder
// när ni godkänt vilka som ska visas publikt. Behåll structure/roller som de är.

export interface TeamMember {
  /** Publikt namn. Sätt tomt string för att dölja namn och bara visa roll. */
  name: string;
  /** Rolltitel som visas under namnet. */
  role: string;
  /** En mening om vad personen faktiskt gör i era projekt. */
  bio: string;
  /** Sökväg till porträtt (public/). Tomt string = initial-avatar renderas. */
  photo?: string;
}

export const team: TeamMember[] = [
  {
    name: "",
    role: "Grundare & producent",
    bio: "Håller i strategimötet, sätter briefen och driver leveransen från första samtal till sista klipp.",
    photo: "",
  },
  {
    name: "",
    role: "Produktionsledare",
    bio: "Din kontaktperson när ni är igång. Bokar inspelningsdagar, håller kalendern och ser till att klippen landar i tid.",
    photo: "",
  },
];
